module.exports = __webpack_public_path__ + "img/add-image12.2045bed0.png";